/* eslint-disable react/prop-types */
import React from 'react'
import styled from 'styled-components'
import { Spin } from 'antd'

const Wrapper = styled.div`
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 9999; 
  
  .ant-spin-spinning {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 99999;
    transform: translate(-50%, -50%);
  }
  ${({ loadingMini }) => loadingMini && `
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 99999;
    transform: translate(-50%, -50%);
    background: rgba(0,0,0,0.2);
  `
}
`

const Loading = (props) => (
  <Wrapper {...props}>
    <Spin size="large" />
  </Wrapper>
)

export default Loading
